<div class="d-flex flex-column">
  <div class="mt-2 attribute-image-row">
    <lib-image-section
      [image]="value ?? undefined"
      [title]="attributeValue.name"
      [index]="0"
      [editEnabled]="!uploading"
      [inputId]="'image_edit_' + attributeValue.attributeDefinitionId"
      [imageSectionExpanded]="true"
      (fileChange)="onFileChange($event)"
    >
    </lib-image-section>
    <div *ngIf="uploading" class="spinner-border spinner-border-sm" role="status"></div>
    <div *ngIf="error" class="invalid-feedback d-block">
      {{ error.key | translate: error.params }}
    </div>
  </div>
</div>
